// baseurl.js

// Backend API base URL
// export const baseurl = "http://localhost:5000/api"; 
// export const baseurl = "http://192.168.1.10:5000/api"; 
export const baseurl = "https://rest1back.restrowave.in/api"; 

// Image base URL (for static uploads)
// export const imgurl = "https://lightpink-chicken-279794.hostingersite.com/"; 
// export const imgurl = "http://192.168.1.10:5000"; 
// export const imgurl = "http://localhost:5000";
export const imgurl = "https://rest1back.restrowave.in"; 


// export const frontendurl = "http://192.168.1.10:3000"; 
// export const frontendurl = "http://localhost:3000"; 
export const frontendurl = "https://dashboard.restrowave.in"; 
